/**
 * Application Constants
 */

export const DEFAULT_LANGUAGE = import.meta.env.VITE_DEFAULT_LANGUAGE || 'ar';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://nova.rocketproxy7.shop/api';

export const ENV = import.meta.env.VITE_ENV || 'development';

